import { IconWrapper } from '../runtime';
export default IconWrapper('poster', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("circle", {
    "attrs": {
      "cx": "10.2792",
      "cy": "9.67059",
      "r": "1.12873",
      "transform": "rotate(-30 10.2792 9.67059)",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M4.06342 8.92209C2.94024 10.536 3.72118 12.8696 5.75469 13.7383C7.78821 14.6069 9.91601 14.2321 11.831 13.1264C13.5754 12.1193 15.2516 10.1531 14.75 8.39999C14.4301 7.28139 13.1449 7.05794 12.6256 7.04276C12.89 4.84741 11.9352 4.37729 11.9352 4.37729M1.09961 10.6221L14.5503 2.86209M11.0057 4.90976L9.12448 1.65139C8.91668 1.29148 8.45647 1.16817 8.09656 1.37596L2.23151 4.76215C1.8716 4.96995 1.74828 5.43016 1.95608 5.79007L3.83729 9.04843L11.0057 4.90976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});